import type { ReactNode } from 'react'

import { Toaster } from '@/components/ui/sonner'
import { useFlash } from '@/hooks/use-flash'
import { MetaTags } from '@/components/meta-tags'
import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { usePage } from '@inertiajs/react'
import { root_path } from '@/lib/routes'

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  const { url } = usePage()
  return (
    <>
      <MetaTags />
      {url !== root_path() && <Header />}
      {children}
      <Footer />
      <Toaster richColors />
    </>
  )
}
